import img_upload from "assets/img/upload.svg";

import { Box, Typography } from "@mui/material";
import { useRef } from "react";

export const InputFileDropBox = ({
  description,
  file,
  setFile,
}: {
  description: string;
  file: any;
  setFile: (file: any) => any;
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",

        minHeight: "100px",
        padding: "12px",
        border: "2px dashed #00000040",
        borderRadius: "8px",

        textAlign: "center",
        cursor: "pointer",
        opacity: "0.6",

        "&:hover": {
          opacity: 0.8,
          border: "2px dashed #00000080",
        },
      }}
      onClick={() => {
        setFile(null);
        fileInputRef.current?.click();
      }}
    >
      {!!file ? (
        <>
          <Typography>Файл загружен</Typography>
          <Typography>{file.name}</Typography>
          <Typography>Нажмите чтобы заменить</Typography>
        </>
      ) : (
        <>
          <Box
            component={"img"}
            src={img_upload}
            width={"20px"}
            height={"20px"}
          />
          <Typography fontSize={"16px"}>{description}</Typography>
        </>
      )}
      <input
        ref={fileInputRef}
        type="file"
        onChange={(e) => {
          if (!e) return;
          const files = e.target.files;
          if (!files) return;
          setFile(files[0]);
        }}
        style={{ display: "none" }}
      />
    </Box>
  );
};
